import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import { Alert, Chip, Tooltip } from '@mui/material';
import type { ContentOrigin } from '@/types/domain';

const LABELS: Record<ContentOrigin, { label: string; help: string }> = {
  user: { label: 'Your content', help: 'Created by you.' },
  examforge_original: { label: 'TradePrep original', help: 'Original content written by TradePrep.' },
  provider_original: { label: 'Provider original', help: 'Original content written by the content provider.' },
  licensed: { label: 'Licensed', help: 'Content used under licence from its owner.' },
  official: { label: 'Official', help: 'Official material published with the authorisation of the issuing body.' },
};

/** Transparent provenance label — never implies endorsement unless official. */
export function OriginBadge({ origin }: { origin: ContentOrigin }) {
  const meta = LABELS[origin];
  return (
    <Tooltip title={meta.help}>
      <Chip
        size="small"
        icon={origin === 'official' ? <VerifiedOutlinedIcon /> : undefined}
        label={meta.label}
        color={origin === 'official' ? 'success' : 'default'}
        variant="outlined"
      />
    </Tooltip>
  );
}

export function DemoChip() {
  return <Chip size="small" color="warning" variant="outlined" icon={<ScienceOutlinedIcon />} label="Demo content" />;
}

export function DisclaimerBanner({ text }: { text: string | null | undefined }) {
  if (!text) return null;
  return (
    <Alert severity="info" icon={<ScienceOutlinedIcon />} sx={{ mb: 2 }}>
      {text}
    </Alert>
  );
}

/** On a learner's own question made from their notes with Plus (provider-approved questions never carry it). */
export function AiGeneratedChip() {
  return (
    <Tooltip title="Made by AI from your notes. Check it against your course material.">
      <Chip size="small" color="secondary" variant="outlined" label="AI-assisted" />
    </Tooltip>
  );
}
